var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97943 4C8.72169 4 9.32377 4.63559 9.32377 5.41916C9.32377 6.20274 8.72169 6.83833 7.97943 6.83833C7.23717 6.83833 6.63509 6.20274 6.63509 5.41916C6.63509 4.63559 7.23717 4 7.97943 4ZM6.8248 7.056H7.37737C7.3856 7.29977 7.66603 7.49134 7.99591 7.49134C8.33407 7.49134 8.60622 7.29977 8.62268 7.056H9.17525C9.62884 7.056 10 7.44781 10 7.92666V10.1293C10 10.6082 9.62884 11 9.17525 11H6.82475C6.37115 11 6 10.6082 6 10.1293V7.92666C6 7.44781 6.37115 7.056 6.82475 7.056H6.8248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/userInfo.945a4a48.svg";
export { ForwardRef as ReactComponent };